import { Box, Stack } from "@mui/material";
import AutoCompleteList from "components/AutoCompleteList";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocationsThunk, locationSelector } from "store/reducers/inventory/locationSlice";


const LocationPanel = ({ filter, setFilter }) => {
  const dispatch = useDispatch();
  const locations = useSelector(locationSelector.selectAll);
  useEffect(() => {
    dispatch(getLocationsThunk());
  }, []);

  return (
    <Box>
      <Stack direction="column" spacing={1.5}>
        <AutoCompleteList
          items={locations}
          name="name"
          label="Filter by location"
          setValue={(value) => {
            setFilter({
              ...filter,
              location: value,
            });
          }}
          value={filter.location}
        />
      </Stack>
    </Box>
  );
};

export default LocationPanel;
